import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { 
  Menu, X, Mail, Phone, ChevronRight, ChevronDown,
  ShoppingCart, MonitorSmartphone, Wrench, PackageSearch, Shuffle,
  Wallet, Receipt, Calculator, PieChart, CarFront, Hammer, Droplets, Frame,
  Store, Users, Factory, Truck, Smartphone, CreditCard, GraduationCap
} from "lucide-react";
import { Button } from "../ui/Button";
import { cn } from "../../lib/utils";

export const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const mainLinks = [
    { label: "PREÇO", href: "/preco" },
  ];

  const megaMenu = {
    operacional: [
      { title: "Catálogo de Vendas", desc: "Gerencie pedidos e notas", icon: <ShoppingCart className="w-5 h-5" />, href: "/catalogo-vendas" },
      { title: "PDV Frente Caixa", desc: "Vendas rápidas com NFC-e", icon: <MonitorSmartphone className="w-5 h-5" />, href: "/pdv" },
      { title: "Ordem de Serviço", desc: "Controle de ponta a ponta", icon: <Wrench className="w-5 h-5" />, href: "/ordem-servico" },
      { title: "Controle de Estoque", desc: "Controle produtos e estoques", icon: <PackageSearch className="w-5 h-5" />, href: "/estoque" },
      { title: "Venda Cruzada", desc: "Aumente o ticket médio", icon: <Shuffle className="w-5 h-5" />, href: "/venda-cruzada" },
    ],
    financeira: [
      { title: "Contas a Pagar", desc: "Controle de despesas", icon: <Receipt className="w-5 h-5" />, href: "/contas-pagar" },
      { title: "Contas a Receber", desc: "Gestão de recebimentos", icon: <Wallet className="w-5 h-5" />, href: "/contas-receber" },
      { title: "Controle de Caixa", desc: "Fluxo e conciliação bancária", icon: <Calculator className="w-5 h-5" />, href: "/controle-caixa" },
      { title: "Insights & Relatórios", desc: "Análises de performance e DRE", icon: <PieChart className="w-5 h-5" />, href: "/relatorios" },
    ]
  };

  const industriasLeft = [
    { title: "Oficina Mecânica", desc: "Gestão completa para sua oficina automotiva.", icon: <Wrench className="w-5 h-5" />, href: "/industrias/oficina-mecanica" },
    { title: "Moto e Autopeças", desc: "Emita notas fiscais, controle estoque e PDV.", icon: <ShoppingCart className="w-5 h-5" />, href: "/industrias/autopecas" },
    { title: "Centro Automotivo", desc: "Cadastre clientes e controle ordens de serviço.", icon: <CarFront className="w-5 h-5" />, href: "/industrias/centro-automotivo" },
    { title: "Funilaria", desc: "Gestão de orçamentos e serviços de pintura.", icon: <Hammer className="w-5 h-5" />, href: "/industrias/funilaria" },
    { title: "Lava Jato", desc: "Controle diário rápido e simples de lavagens.", icon: <Droplets className="w-5 h-5" />, href: "/industrias/lava-jato" },
    { title: "Auto Glass", desc: "Reparos de vidros, peças e serviços diversos.", icon: <Frame className="w-5 h-5" />, href: "/industrias/auto-glass" },
  ];

  const solucoesParaQuem = [
    { title: "Vende online", desc: "Gerencie todo seu processo de vendas online, integre com plataformas e emita notas fiscais", icon: <ShoppingCart className="w-5 h-5" />, href: "/solucoes/vende-online" },
    { title: "Tem loja física", desc: "Emita notas fiscais, controle estoque e gerencie frente de caixa (PDV) na sua loja física", icon: <Store className="w-5 h-5" />, href: "/solucoes/loja-fisica" },
    { title: "Oferece serviço", desc: "Cadastre clientes, controle ordens de serviço, faça gestão financeira e envie links de pagamento", icon: <Users className="w-5 h-5" />, href: "/solucoes/oferece-servico" },
    { title: "Tem pequena indústria", desc: "Gerencie suprimentos e estoque, controle ordem de produção e emita notas fiscais", icon: <Factory className="w-5 h-5" />, href: "/solucoes/pequena-industria" },
  ];

  const recursosTemNoRosTech = [
    { 
      title: "Envios Integrados", 
      desc: "Gerencie a separação e envio de remessas em diversos operadores logísticos.", 
      icon: <Truck className="w-8 h-8 text-blue-600" />,
      bgIcon: "bg-blue-100",
      bgCard: "bg-blue-50/50",
      href: "/recursos/envios"
    },
    { 
      title: "RosTech Conta Digital", 
      desc: "Otimize a gestão do seu negócio integrando automaticamente as movimentações financeiras.", 
      icon: <Smartphone className="w-8 h-8 text-emerald-600" />,
      bgIcon: "bg-emerald-100",
      bgCard: "bg-emerald-50/50",
      href: "/recursos/conta-digital"
    },
    { 
      title: "Maquininha POS", 
      desc: "Automatize o processo de recebimento e conciliação das vendas realizadas com cartão.", 
      icon: <CreditCard className="w-8 h-8 text-teal-600" />,
      bgIcon: "bg-teal-100",
      bgCard: "bg-teal-50/50",
      href: "/recursos/maquininha"
    },
    { 
      title: "Mentoria", 
      desc: "Mentoria para empresários de oficina mecânica e autopeças.", 
      icon: <GraduationCap className="w-8 h-8 text-orange-600" />,
      bgIcon: "bg-orange-100",
      bgCard: "bg-orange-50/50",
      href: "/recursos/mentoria"
    },
  ];

  return (
    <>
      {/* Secondary Bar */}
      <div className="hidden border-b border-slate-800 bg-slate-900 md:flex items-center justify-between px-10 py-2 text-[11px] text-slate-400 font-medium tracking-wide relative z-50">
        <div className="flex items-center space-x-6">
          <div className="flex items-center hover:text-blue-500 transition-colors cursor-pointer">
            <Mail className="w-3.5 h-3.5 mr-2" />
            contato@rostech.com.br
          </div>
          <div className="flex items-center hover:text-blue-500 transition-colors cursor-pointer">
            <Phone className="w-3.5 h-3.5 mr-2" />
            (24) 9.9281-8632
          </div>
        </div>
        <div className="flex items-center space-x-6">
          <Link to="/sobre" className="hover:text-blue-400 transition-colors">Sobre</Link>
          <Link to="/blog" className="hover:text-blue-400 transition-colors">Blog</Link>
          <div className="w-px h-3 bg-slate-700 mx-1"></div>
          <Link to="/login" className="hover:text-blue-400 transition-colors font-bold text-white uppercase tracking-wider">Login</Link>
          <Link to="/cadastro" className="bg-white text-slate-900 px-3 py-1 rounded-sm font-bold uppercase tracking-wider hover:bg-slate-100 transition-colors">Cadastro</Link>
        </div>
      </div>

      <header className="w-full flex-col sticky top-0 z-50 flex">
        {/* Main Navigation */}
      <div className="px-10 py-0 flex items-center border-b border-slate-200 shadow-[0_10px_30px_-5px_rgba(0,0,0,0.05)] bg-white">
        <div className="flex items-center mr-auto">
          <Link to="/" className="flex items-center space-x-2 py-4">
            <div className="bg-blue-700 text-white p-1.5 rounded">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"/>
                <path d="m9 12 2 2 4-4"/>
              </svg>
            </div>
            <span className="text-2xl font-black tracking-tighter text-slate-900">ROS<span className="text-blue-700">TECH</span></span>
          </Link>
        </div>

        {/* Desktop Menu */}
        <nav className="hidden lg:flex items-center space-x-8 xl:space-x-10 mr-12 h-full">
          {/* Mega Menu Item */}
          <div className="relative group h-full flex items-center">
            <button className="flex items-center text-[12px] font-bold tracking-[0.1em] text-slate-700 hover:text-blue-700 transition-colors h-full py-6">
              MÓDULOS <ChevronDown className="w-4 h-4 ml-1 opacity-60" />
            </button>
            
            {/* Dropdown Content */}
            <div className="absolute top-full left-1/2 w-[700px] bg-white rounded-b-2xl shadow-[0_20px_50px_-15px_rgba(0,0,0,0.15)] border border-slate-100 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 transform -translate-x-1/2 -translate-y-2 group-hover:translate-y-0 z-50">
              <div className="flex p-8 gap-8">
                {/* Gestão Operacional */}
                <div className="flex-1">
                  <h3 className="text-blue-700 font-extrabold text-sm uppercase tracking-wider mb-5 flex items-center gap-2">
                    Gestão Operacional
                  </h3>
                  <div className="space-y-4">
                    {megaMenu.operacional.map((item, idx) => (
                      <Link key={idx} to={item.href} className="flex items-start group/item">
                        <div className="bg-slate-50 text-slate-500 p-2.5 rounded-lg mr-4 group-hover/item:bg-blue-50 group-hover/item:text-blue-700 transition-colors border border-slate-100 group-hover/item:border-blue-100">
                          {item.icon}
                        </div>
                        <div className="pt-0.5">
                          <p className="font-bold text-sm text-slate-900 group-hover/item:text-blue-700 transition-colors mb-0.5">{item.title}</p>
                          <p className="text-[13px] text-slate-500 leading-tight">{item.desc}</p>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>
                
                {/* Gestão Financeira */}
                <div className="flex-1">
                  <h3 className="text-blue-700 font-extrabold text-sm uppercase tracking-wider mb-5 flex items-center gap-2">
                    Gestão Financeira
                  </h3>
                  <div className="space-y-4">
                    {megaMenu.financeira.map((item, idx) => (
                      <Link key={idx} to={item.href} className="flex items-start group/item">
                        <div className="bg-slate-50 text-slate-500 p-2.5 rounded-lg mr-4 group-hover/item:bg-blue-50 group-hover/item:text-blue-700 transition-colors border border-slate-100 group-hover/item:border-blue-100">
                          {item.icon}
                        </div>
                        <div className="pt-0.5">
                          <p className="font-bold text-sm text-slate-900 group-hover/item:text-blue-700 transition-colors mb-0.5">{item.title}</p>
                          <p className="text-[13px] text-slate-500 leading-tight">{item.desc}</p>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
              <div className="bg-slate-50 p-4 rounded-b-2xl border-t border-slate-100 flex items-center justify-center">
                 <Link to="/modulos" className="text-sm font-bold text-blue-700 hover:text-blue-800 flex items-center transition-colors">
                    Ver todos os módulos <ChevronRight className="w-4 h-4 ml-1" />
                 </Link>
              </div>
            </div>
          </div>

          {/* Mega Menu Indústrias Item */}
          <div className="relative group h-full flex items-center">
            <button className="flex items-center text-[12px] font-bold tracking-[0.1em] text-slate-700 hover:text-blue-700 transition-colors h-full py-6">
              INDÚSTRIAS <ChevronDown className="w-4 h-4 ml-1 opacity-60" />
            </button>
            
            {/* Dropdown Content */}
            <div className="absolute top-full left-1/2 w-[600px] bg-white rounded-b-2xl shadow-[0_20px_50px_-15px_rgba(0,0,0,0.15)] border border-slate-100 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 transform -translate-x-1/2 -translate-y-2 group-hover:translate-y-0 z-50">
              <div className="p-8">
                <h3 className="text-blue-700 font-extrabold text-sm uppercase tracking-wider mb-6">
                  PARA QUEM
                </h3>
                <div className="grid grid-cols-2 gap-x-8 gap-y-6">
                  {industriasLeft.map((item, idx) => (
                    <Link key={idx} to={item.href} className="flex items-start group/item">
                      <div className="bg-green-50/50 text-green-700 p-2.5 rounded-lg mr-4 group-hover/item:bg-green-100 transition-colors shrink-0">
                        {item.icon}
                      </div>
                      <div className="pt-0.5">
                        <p className="font-bold text-sm text-slate-900 group-hover/item:text-blue-700 transition-colors mb-0.5">{item.title}</p>
                        <p className="text-[12px] text-slate-500 leading-tight">{item.desc}</p>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Mega Menu Soluções Item */}
          <div className="relative group h-full flex items-center">
            <button className="flex items-center text-[12px] font-bold tracking-[0.1em] text-slate-700 hover:text-blue-700 transition-colors h-full py-6">
              SOLUÇÕES <ChevronDown className="w-4 h-4 ml-1 opacity-60" />
            </button>
            
            {/* Dropdown Content */}
            <div className="absolute top-full left-1/2 w-[600px] border-t-2 border-green-500 bg-white rounded-b-2xl shadow-[0_30px_60px_-15px_rgba(0,0,0,0.2)] border-x border-b border-slate-100 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 transform -translate-x-1/2 -translate-y-2 group-hover:translate-y-0 z-50 overflow-hidden">
              <div className="p-8 bg-white">
                <h3 className="text-green-700 font-extrabold text-sm uppercase tracking-wider mb-6">
                  PARA QUEM
                </h3>
                <div className="grid grid-cols-2 gap-x-8 gap-y-6">
                  {solucoesParaQuem.map((item, idx) => (
                    <Link key={idx} to={item.href} className="flex items-start group/item">
                      <div className="bg-green-50/80 text-green-700 p-2.5 rounded-xl mr-4 group-hover/item:bg-green-100 transition-colors shrink-0">
                        {item.icon}
                      </div>
                      <div className="pt-0.5">
                        <p className="font-bold text-sm text-slate-900 group-hover/item:text-green-700 transition-colors mb-0.5">{item.title}</p>
                        <p className="text-[12px] text-slate-500 leading-tight">{item.desc}</p>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Mega Menu Recursos Item */}
          <div className="relative group h-full flex items-center">
            <button className="flex items-center text-[12px] font-bold tracking-[0.1em] text-slate-700 hover:text-blue-700 transition-colors h-full py-6">
              RECURSOS <ChevronDown className="w-4 h-4 ml-1 opacity-60" />
            </button>
            
            {/* Dropdown Content */}
            <div className="absolute top-full left-1/2 w-[850px] border-t-2 border-blue-500 bg-white rounded-b-2xl shadow-[0_30px_60px_-15px_rgba(0,0,0,0.2)] border-x border-b border-slate-100 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 transform -translate-x-[70%] -translate-y-2 group-hover:translate-y-0 z-50 overflow-hidden">
              <div className="p-6">
                <h3 className="text-blue-700 font-extrabold text-sm uppercase tracking-wider mb-5">
                  TAMBÉM TEM NO ROSTECH
                </h3>
                <div className="grid grid-cols-4 gap-4">
                  {recursosTemNoRosTech.map((item, idx) => (
                    <Link key={idx} to={item.href} className="group/card block h-full">
                      <div className={cn("rounded-2xl p-4 border border-slate-100 transition-all duration-300 group-hover/card:-translate-y-1 group-hover/card:shadow-lg mb-3 h-40 flex items-center justify-center", item.bgCard)}>
                        <div className={cn("w-16 h-16 shadow-sm rounded-full flex items-center justify-center bg-white shrink-0", item.bgIcon)}>
                          {item.icon}
                        </div>
                      </div>
                      <div>
                        <p className="font-bold text-sm text-slate-900 mb-1">{item.title}</p>
                        <p className="text-[12px] text-slate-500 leading-relaxed line-clamp-3">{item.desc}</p>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {mainLinks.map((link) => (
            <Link
              key={link.label}
              to={link.href}
              className={cn(
                "text-[12px] font-bold tracking-[0.1em] hover:text-blue-700 transition-colors py-6",
                location.pathname === link.href ? "text-blue-700" : "text-slate-700"
              )}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* Action Button */}
        <div className="hidden lg:flex items-center space-x-4">
          <Link to="/cadastro">
            <Button variant="primary" size="md">
              Teste Grátis
            </Button>
          </Link>
        </div>

        {/* Mobile menu button */}
        <button 
          className="lg:hidden p-2 text-slate-600"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile Menu Content */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-b border-slate-200 overflow-y-auto max-h-[calc(100vh-130px)] shadow-lg absolute w-full left-0 top-full">
          <div className="flex flex-col px-4 py-6 space-y-4">
            <div className="border-b border-slate-100 pb-2">
               <div className="text-base font-bold tracking-wider text-slate-700 py-2">MÓDULOS</div>
               <div className="pl-4 space-y-3 mt-2 mb-4">
                  <div className="font-semibold text-blue-700 text-sm mb-2">Gestão Operacional</div>
                  {megaMenu.operacional.map((item, idx) => (
                     <Link key={idx} to={item.href} className="block text-sm text-slate-600 py-1" onClick={() => setIsMobileMenuOpen(false)}>{item.title}</Link>
                  ))}
                  <div className="font-semibold text-blue-700 text-sm mb-2 mt-4">Gestão Financeira</div>
                  {megaMenu.financeira.map((item, idx) => (
                     <Link key={idx} to={item.href} className="block text-sm text-slate-600 py-1" onClick={() => setIsMobileMenuOpen(false)}>{item.title}</Link>
                  ))}
               </div>
            </div>

            <div className="border-b border-slate-100 pb-2">
               <div className="text-base font-bold tracking-wider text-slate-700 py-2">INDÚSTRIAS</div>
               <div className="pl-4 space-y-3 mt-2 mb-4">
                  {industriasLeft.map((item, idx) => (
                     <Link key={idx} to={item.href} className="block text-sm text-slate-600 py-1" onClick={() => setIsMobileMenuOpen(false)}>{item.title}</Link>
                  ))}
               </div>
            </div>

            <div className="border-b border-slate-100 pb-2">
               <div className="text-base font-bold tracking-wider text-slate-700 py-2">SOLUÇÕES</div>
               <div className="pl-4 space-y-3 mt-2 mb-4">
                  <div className="font-semibold text-green-700 text-sm mb-2">Para Quem</div>
                  {solucoesParaQuem.map((item, idx) => (
                     <Link key={idx} to={item.href} className="block text-sm text-slate-600 py-1" onClick={() => setIsMobileMenuOpen(false)}>{item.title}</Link>
                  ))}
               </div>
            </div>

            <div className="border-b border-slate-100 pb-2">
               <div className="text-base font-bold tracking-wider text-slate-700 py-2">RECURSOS</div>
               <div className="pl-4 space-y-3 mt-2 mb-4">
                  <div className="font-semibold text-blue-700 text-sm mb-2">Também tem no RosTech</div>
                  {recursosTemNoRosTech.map((item, idx) => (
                     <Link key={idx} to={item.href} className="block text-sm text-slate-600 py-1" onClick={() => setIsMobileMenuOpen(false)}>{item.title}</Link>
                  ))}
               </div>
            </div>

            {mainLinks.map((link) => (
              <Link
                key={link.label}
                to={link.href}
                className="text-base font-bold tracking-wider text-slate-700 hover:text-blue-700 py-2 border-b border-slate-100 flex items-center justify-between"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {link.label}
                <ChevronRight className="w-4 h-4 text-slate-400" />
              </Link>
            ))}
            <div className="pt-4 grid grid-cols-2 gap-4">
              <Link to="/login" onClick={() => setIsMobileMenuOpen(false)}>
                <Button variant="outline" className="w-full">Login</Button>
              </Link>
              <Link to="/cadastro" onClick={() => setIsMobileMenuOpen(false)}>
                <Button variant="primary" className="w-full">Cadastrar</Button>
              </Link>
            </div>
            <div className="mt-8 pt-4 border-t border-slate-100 flex flex-col space-y-3 text-sm text-slate-500">
              <div className="flex items-center">
                <Mail className="w-4 h-4 mr-2" />
                contato@rostech.com.br
              </div>
              <div className="flex items-center">
                <Phone className="w-4 h-4 mr-2" />
                (24) 9.9281-8632
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
    </>
  );
};
